import {
    ClientSummaryServiceClient,
    ListClientSummaryRequest,
    ListMarginRequirementDetailsRequest,
    ListSegregationDetailsRequest,
  } from '../proto/reportpb/clientsummary_grpc_web_pb';
  import { stringToProtoDate } from './ConvertService';
  import { auth } from '../lib/auth/Auth';
  
  const service = new ClientSummaryServiceClient(
    window.env.GRPC_ENDPOINT,
    {},
    { ...auth }
  );
  
  export async function listClientSummary(param) {
    return new Promise((resolve, reject) => {
      let req = new ListClientSummaryRequest();
      req.setDate(stringToProtoDate(param.date));
      req.setAccountNo(param.accountNo);
  
      service.listClientSummary(req, {}, (error, response) => {
        if (error) {
          reject(error);
        } else {
          resolve(response.toObject());
        }
      });
    });
  }
  
  export async function listMarginReqDetails(param) {
    return new Promise((resolve, reject) => {
      let req = new ListMarginRequirementDetailsRequest();
      req.setDate(stringToProtoDate(param.date));
      req.setMasterAccountNo(param.masterAccountNo);
  
      service.listMarginRequirementDetails(req, {}, (error, response) => {
        if (error) {
          reject(error);
        } else {
          resolve(response.toObject());
        }
      });
    });
  }
  
  export async function listSegregationDetails(param) {
    return new Promise((resolve, reject) => {
      let req = new ListSegregationDetailsRequest();
      req.setDate(stringToProtoDate(param.date));
      req.setMasterAccountNo(param.masterAccountNo);
  
      service.listSegregationDetails(req, {}, (error, response) => {
        if (error) {
          reject(error);
        } else {
          resolve(response.toObject());
        }
      });
    });
  }